import { postSendSmsTest } from '../services';
export const sendSmsTest = (mobileNumber, message) => postSendSmsTest(mobileNumber, message)
    .then(response => formatResponse(response?.data))
    .catch(() => false);
const formatResponse = (response) => {
    return response.success;
};
